import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import FeatureCompatibilityMatrix from './FeatureCompatibilityMatrix';
import LoadingWrapper from '../../layout/components/LoadingWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FeatureCompatibilityModal({
  appContext,
  featuresWithTierCompatibility,
  offeringType,
  onClose,
  portalTiers,
  requestState,
  tierGroupNames,
  trackInteraction
}) {
  return /*#__PURE__*/_jsxs(UIModal, {
    width: "90%",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-common.compatibility.featureCompatibilityModal.header"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      className: "p-all-0",
      children: /*#__PURE__*/_jsx(LoadingWrapper, {
        requestStatus: requestState,
        children: /*#__PURE__*/_jsx(FeatureCompatibilityMatrix, {
          featuresWithTierCompatibility: featuresWithTierCompatibility,
          featureType: unescapedText(`marketplace-ui-common.compatibility.offeringType.${offeringType}`),
          isCustomer: appContext === 'app',
          portalTiers: portalTiers,
          tierGroupNames: tierGroupNames,
          trackPricingLinkClick: tierGroup => trackInteraction('click compatibility modal pricing link', {
            section: 'overview',
            value: tierGroup
          })
        })
      })
    })]
  });
}